import { createContext, useContext } from 'react'
export const DashBoardContext = createContext({})
export const useDashboardContext = () => useContext(DashBoardContext)